import styled from "styled-components";
import SpriteImage from "@PUBLIC/P/images/ico/ico_spr.png";

const Wrap = styled.div`
	margin-top: 60px;

	table {
		th {
			min-width: 100px;
		}
	}
`;

const TitArea = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 20px;
`;

const DayText = styled.p`
	font-size: var(--basic-size);
	color: var(--default-color);
	> span:first-of-type {
		margin-right: 8px;
	}
`;

const SelectWrap = styled.div`
	position: relative;
	display: inline-block;
	width: 240px;
	height: 37px;
	margin-left: 10px;
`;

const TimeInfoWrap = styled.div`
	display: block;
`;

const TimeInfo = styled.p`
	position: relative;
	display: inline-block;
	line-height: 28px;
	padding-left: 28px;
	margin: 0 10px 2px 0;
	&::before {
		position: absolute;
		top: 5px;
		left: 0;
		display: inline-block;
		width: 18px;
		height: 19px;
		background: url(${SpriteImage}) no-repeat 0 -247px;
		vertical-align: middle;
		content: "";
	}
`;

const TimeText = styled.span`
	margin-left: 5px;
	margin-right: 5px;
	font-size: 16px;
	color: var(--emp-color);
`;

const DollerInfo = styled.div`
	position: relative;
	display: inline-block;
	line-height: 28px;
	padding-left: 28px;
	margin: 0 10px 2px 0;
	vertical-align: middle;

	&::before {
		position: absolute;
		top: 3px;
		left: 0;
		display: inline-block;
		width: 18px;
		height: 20px;
		background: url(${SpriteImage}) no-repeat 0 -306px;
		content: "";
	}
`;

const DollerText = styled.span`
	margin-right: 5px;
	font-size: 16px;
	color: var(--emp-color);
`;

export {DayText, DollerInfo, DollerText, SelectWrap, TimeInfo, TimeInfoWrap, TimeText, TitArea, Wrap};
